<template>
  <div class="container">
    <div class="header">
      <div class="nav second" :class="{ en: $i18n.locale == 'en' }">
        <router-link to="/" :class="{ active: this.$route.name == 'Home' }">{{
          $t("m.header.support")
        }}</router-link>
        <!-- :class="{ active: this.$route.name == 'KNOW ISSUES' }" -->
        <a
          target="_blank"
          :href="
            $i18n.locale == 'en'
              ? 'https://trello.com/b/aDzm1dnM/'
              : 'https://banlikanban.com/kanban/64d1afd3580bfb2671125901/%E6%AC%A2%E8%BF%8E%E6%9F%A5%E7%9C%8B%E6%9D%BF%E6%A0%97%E7%9C%8B%E6%9D%BF%E3%80%8C%E7%8C%9B%E5%85%BD%E6%B4%BE%E5%AF%B9%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98%E3%80%8D'
          "
          >{{ $t("m.header.known") }}</a
        >

        <router-link
          to="/server"
          :class="{ active: this.$route.name == 'Serve' }"
          >{{ $t("m.header.server") }}</router-link
        >
        <router-link
          :to="this.$store.state.login ? '/tickets/my-tickets' : '/login'"
          :class="{ active: this.$route.name == 'Myticket' }"
          >{{ $t("m.header.ticket") }}</router-link
        >
        <router-link
          :class="{ active: this.$route.name == 'submit a ticket' }"
          :to="$store.state.login ? { path: '/tickets/new-tickets' } : '/login'"
          id="sub-btn"
          exact
          >{{ $t("m.header.submit") }}</router-link
        >

        <div class="log" @click="login()" v-if="!this.$store.state.login">
          <svg
            class="user"
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 26.8 26.8"
            style="enable-background: new 0 0 26.8 26.8"
            xml:space="preserve"
          >
            <path
              class="st0"
              d="M13.4,0C6,0,0,6,0,13.4c0,7.4,6,13.4,13.4,13.4c7.4,0,13.4-6,13.4-13.4C26.8,6,20.8,0,13.4,0z M13.4,3.9
	c2.6,0,4.7,2.1,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7C8.7,6,10.8,3.9,13.4,3.9z M13.4,23.9c-2.8,0-5.4-1.1-7.3-2.9
	c1-3.1,3.9-5.1,7.2-5.1c3.4,0,6.3,2.1,7.3,5.1C18.8,22.7,16.2,23.9,13.4,23.9z"
            />
          </svg>
          <svg
            class="login"
            v-if="this.$i18n.locale == 'en'"
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 65.8 15.7"
            style="enable-background: new 0 0 65.8 15.7"
            xml:space="preserve"
          >
            <g>
              <path
                class="st0"
                d="M7.7,15.5H2.4c-0.8,0-1.4-0.2-1.8-0.6c-0.4-0.4-0.6-1-0.6-1.8V2.4c0-0.7,0.2-1.3,0.6-1.7
		c0.4-0.4,1-0.6,1.7-0.6C3,0.1,3.6,0.4,4,0.8c0.4,0.4,0.6,1,0.6,1.7l0,8.8h3.1c0.7,0,1.2,0.2,1.6,0.6c0.4,0.4,0.6,0.9,0.6,1.6
		S9.7,14.6,9.3,15S8.4,15.5,7.7,15.5z"
              />
              <path
                class="st0"
                d="M19,15.7c-2.5,0-4.4-0.7-5.9-2.2c-1.4-1.4-2.2-3.3-2.2-5.7c0-2.3,0.7-4.2,2.2-5.7S16.6,0,19,0
		c2.4,0,4.4,0.7,5.8,2.2S27,5.6,27,7.9c0,2.3-0.7,4.2-2.1,5.7C23.4,15,21.5,15.7,19,15.7z M19,11.6c1,0,1.8-0.3,2.4-1
		c0.6-0.6,0.9-1.6,0.9-2.8c0-1.2-0.3-2.1-0.9-2.8c-0.6-0.6-1.4-1-2.3-1s-1.7,0.3-2.3,1c-0.6,0.6-0.9,1.6-0.9,2.8
		c0,1.2,0.3,2.1,0.9,2.8C17.2,11.3,18,11.6,19,11.6z"
              />
              <path
                class="st0"
                d="M36.9,15.7c-2.5,0-4.5-0.7-6-2.1c-1.5-1.4-2.2-3.3-2.2-5.8c0-2.4,0.8-4.4,2.3-5.8S34.5,0,37,0
		c1.6,0,2.7,0.2,3.5,0.7c0.8,0.5,1.2,1.1,1.2,1.9c0,0.6-0.2,1-0.5,1.4c-0.3,0.4-0.8,0.6-1.3,0.6c-0.2,0-0.6-0.1-1.1-0.2
		c-0.5-0.1-1-0.2-1.4-0.2c-1.2,0-2.2,0.3-2.9,0.9c-0.7,0.6-1,1.6-1,2.8c0,1.2,0.3,2.2,1,2.8c0.7,0.6,1.5,1,2.6,1
		c0.3,0,0.6,0,0.9-0.1V9.4c0-0.6,0.2-1.1,0.5-1.5s0.8-0.6,1.5-0.6c0.6,0,1.1,0.2,1.5,0.6C41.8,8.3,42,8.8,42,9.4v3.3
		c0,1-0.4,1.8-1.3,2.3C39.9,15.5,38.6,15.7,36.9,15.7z"
              />
              <path
                class="st0"
                d="M48.4,14.9c-0.4,0.4-1,0.6-1.7,0.6c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-1-0.6-1.7V2.5c0-0.7,0.2-1.3,0.6-1.7
		c0.4-0.4,1-0.6,1.7-0.6c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.7v10.8C49,13.9,48.8,14.5,48.4,14.9z"
              />
              <path
                class="st0"
                d="M55.9,14.9c-0.4,0.4-1,0.6-1.7,0.6c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-1-0.6-1.7V2.6c0-0.8,0.2-1.4,0.6-1.8
		c0.4-0.4,1-0.6,1.7-0.6c0.6,0,1,0.2,1.4,0.5c0.4,0.3,0.9,0.9,1.5,1.8l4,5.5h0l0-5.5c0-0.7,0.2-1.3,0.6-1.7c0.4-0.4,1-0.6,1.7-0.6
		s1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.7v10.7c0,0.8-0.2,1.4-0.6,1.8c-0.4,0.4-1,0.6-1.7,0.6c-0.6,0-1.1-0.2-1.6-0.5
		c-0.4-0.4-1-1-1.8-2.1l-3.6-4.8h0l0,5.1C56.5,13.9,56.3,14.5,55.9,14.9z"
              />
            </g>
          </svg>
          <svg
            class="login zh"
            v-else
            version="1.1"
            id="图层_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 41.5 20.1"
            style="enable-background: new 0 0 41.5 20.1"
            xml:space="preserve"
          >
            <g>
              <path
                class="st0"
                d="M17.4,1.2c0.5,0.7,0.4,1.2-0.2,1.7C17,3.1,16.6,3.3,16,3.7c-0.7,0.4-1.2,0.8-1.5,1C14.7,5,14.9,5.2,15,5.3
		c0.6-0.3,1.5-0.9,2.6-1.6c0.8-0.5,1.4-0.4,2,0.2c0.5,0.7,0.4,1.3-0.2,1.8c-0.2,0.2-0.8,0.6-1.8,1.2c-0.3,0.2-0.5,0.3-0.6,0.3
		c0.7,0.4,1.6,0.9,2.5,1.4c0.8,0.4,1,1.1,0.7,2c-0.3,0.8-1,1.1-1.9,0.8c-0.3-0.2-0.5-0.3-0.8-0.4c0,0.1,0,0.1,0,0.2v2
		c0.1,1.5-0.6,2.2-2,2h-0.1c0.3,0.3,0.3,0.7,0.1,1.1c-0.1,0.1-0.2,0.3-0.4,0.6h3.8c0.8,0.1,1.3,0.5,1.3,1.3
		c-0.1,0.8-0.5,1.3-1.3,1.3H1.7c-0.8-0.1-1.2-0.5-1.3-1.3c0.1-0.8,0.5-1.3,1.3-1.3h3.5c-0.2-0.3-0.3-0.4-0.3-0.5
		c-0.3-0.4-0.3-0.8,0-1.2H4.8c-1.4,0.1-2.1-0.6-2-2v-2v-0.2c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0.1-0.4,0.2-0.5,0.2
		c-0.9,0.4-1.5,0.2-1.9-0.7c-0.2-1,0-1.7,0.7-2.1C1.4,8.5,2.1,8.1,3,7.5c0.1-0.1,0.1-0.1,0.2-0.1C2.7,7,2.2,6.6,1.8,6.3
		C1.2,5.7,1.2,5.1,1.7,4.5C2.4,4,3.1,4,3.8,4.4C3.8,4.4,4.1,4.6,4.5,5c0.4,0.3,0.7,0.5,0.8,0.7c0.4-0.5,0.7-1,1.1-1.5
		C6.5,4,6.5,3.9,6.5,3.9C6.5,3.8,6.4,3.7,6.2,3.7h-4C1.4,3.6,0.9,3.2,0.9,2.4c0.1-0.8,0.5-1.3,1.3-1.3h6.2c0.9,0.1,1.4,0.5,1.5,1.5
		c0,0.9-0.2,1.6-0.5,2.3C9.1,5.2,8.9,5.5,8.7,5.9h3.1c-0.7-1.2-1.3-2.6-1.8-4.3C9.9,0.8,10.2,0.3,11,0c0.9-0.1,1.6,0.2,1.9,1
		c0.2,0.5,0.3,0.9,0.5,1.3c0.8-0.4,1.4-0.8,2-1.2C16.1,0.6,16.8,0.6,17.4,1.2z M14.9,9.3c-0.1-0.1-0.3-0.3-0.6-0.5
		c-0.2-0.2-0.4-0.4-0.6-0.5h-7C6.6,8.4,6.4,8.6,6.1,8.8C5.9,9,5.7,9.2,5.6,9.3H14.9z M6,12.3c-0.1,0.4,0.1,0.6,0.6,0.6h7.2
		c0.4,0.1,0.5-0.1,0.5-0.6v-0.1c0.1-0.4-0.1-0.6-0.5-0.6H6.6C6.2,11.6,6,11.8,6,12.3L6,12.3z M7.6,15.3l0.3,0.4
		C8.6,16.5,8.9,17,9,17h2.5c0.5-0.7,1-1.3,1.2-1.7h0.1H7.6z"
              />
              <path
                class="st0"
                d="M24.8,7.3C24,7.2,23.6,6.8,23.5,6c0.1-0.8,0.5-1.2,1.3-1.2h10.6V4.2c0-0.3-0.1-0.5-0.4-0.5h-11
		c-0.8-0.1-1.2-0.5-1.2-1.3c0.1-0.8,0.5-1.2,1.2-1.2h12.6c1.4,0,2,0.6,2,1.9v5.3h1.4c0.9,0.1,1.3,0.5,1.4,1.3
		c-0.1,0.8-0.6,1.3-1.4,1.4h-1.4c0.3,0.1,0.5,0.2,0.8,0.5c0.5,0.7,0.4,1.4-0.2,2c-0.5,0.4-1.2,0.9-2.1,1.4c0.4,0.2,1.2,0.5,2.4,1
		c0.1,0.1,0.2,0.1,0.3,0.2c0.9,0.5,1.2,1.2,0.7,2.2c-0.5,0.9-1.2,1.2-2.2,0.8c-2-0.8-3.7-2-5.2-3.6v1.1c0.1,2.2-0.9,3.4-2.9,3.5
		c-0.7,0-1.4,0-2.2,0c-0.9,0-1.4-0.4-1.6-1.3c0.1-1,0.5-1.5,1.4-1.6h0.9c0.8,0.1,1.1-0.3,1.1-1.1v-0.7c-2.8,1.4-4.9,2.4-6.3,3.1
		c-0.9,0.3-1.6,0-2-0.9c-0.3-1.1-0.1-1.8,0.7-2.2c0.1-0.1,0.3-0.1,0.5-0.2c0.5-0.2,1.3-0.5,2.5-1l-0.1-0.1h-0.1
		c-0.1,0-0.1-0.1-0.2-0.2c-0.7-0.4-1.1-0.7-1.2-0.8c-0.7-0.5-0.8-1.2-0.4-1.9c0.2-0.2,0.3-0.3,0.5-0.4h-1.1
		c-0.9-0.1-1.3-0.5-1.4-1.4c0.1-0.8,0.5-1.3,1.4-1.3h12.8V7.3H24.8z M26.9,11.9c0.5,0.4,0.7,0.9,0.5,1.6c0.2-0.1,0.5-0.2,1-0.4
		c0.3-0.1,0.8-0.4,1.6-0.7v-1.2h-4.5c0.2,0.1,0.5,0.2,1,0.5C26.6,11.7,26.8,11.8,26.9,11.9z M37.2,11.3c0.1,0,0.1,0,0.2-0.1
		c0.2-0.1,0.3-0.2,0.4-0.2h-4.6v0.3c0.5,0.7,1,1.2,1.5,1.7c0.2-0.1,0.5-0.4,1-0.7C36.4,11.9,37,11.5,37.2,11.3z"
              />
            </g>
          </svg>
        </div>
        <div
          class="hasLogin"
          v-if="this.$store.state.login"
          @click="isLogin = !isLogin"
        >
          <div class="head">
            <img :src="this.$store.state.avatarUrl" alt="" />
          </div>
          <span class="name"> {{ this.$store.state.userName }}</span>
          <div>
            <transition name="fade">
              <div class="outbox" v-if="isLogin">
                <div class="innerbox">
                  <div class="li" @click="Logout()">
                    {{ $t("m.header.out") }}
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="logo">
        <a v-if="this.$i18n.locale == 'zh'" href="https://partyanimals.cn"></a>
        <a v-if="this.$i18n.locale != 'zh'" href="https://partyanimals.com"></a>
      </div>
      <div class="nav-box">
        <div class="nav first">
          <a
            v-if="this.$i18n.locale == 'zh'"
            href="https://partyanimals.cn/media"
            >{{ $t("m.header.media") }}</a
          >
          <a
            v-if="this.$i18n.locale != 'zh'"
            href="https://partyanimals.com/media"
            >{{ $t("m.header.media") }}</a
          >
          <router-link class="active" to="/">{{
            $t("m.header.supportup")
          }}</router-link>
          <!-- <a  ></a> -->
          <a
            v-if="this.$i18n.locale != 'en'"
            href="https://forum-china.partyanimals.com/"
          >
            {{ $t("m.header.forum") }}</a
          >
          <a
            v-if="this.$i18n.locale == 'en'"
            href="https://forum.partyanimals.com/"
          >
            {{ $t("m.header.forum") }}</a
          >

          <ShopBar
            class="win"
            :ul="[
              { lang: '天猫旗舰店', data: 'tianmao' },
              { lang: '京东旗舰店', data: 'jingdong' },
            ]"
          >
          </ShopBar>

          <a
            v-if="this.$i18n.locale != 'en'"
            href="https://partyanimals.cn/events"
          >
            {{ $t("m.header.event") }}</a
          >
          <a
            v-if="this.$i18n.locale == 'en'"
            href="https://partyanimals.com/twitch-drops"
          >
            {{ $t("m.header.event") }}</a
          >
        </div>
      </div>
      <div class="menu" :class="{ zh: this.$i18n.locale == 'zh' }">
        <!-- <img class="global" @click="changeLang = true" src="../assets/images/menu_icon_language.svg" alt="" srcset=""> -->
        <SmallBar
          class="win"
          :ul="[
            { lang: $t('m.header.zh'), data: 'zh' },
            { lang: $t('m.header.en'), data: 'en' },
          ]"
        >
        </SmallBar>
        <!-- <div class="line"></div> -->
        <div class="small" @click="showMenu()">
          <!-- <div class="img" :class="{ active: menuActive }" alt=""> </div> -->

          <svg
            class="svg-menu"
            :style="{ opacity: menuActive ? 0 : 1 }"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="34px"
            height="29px"
          >
            <path
              fill-rule="evenodd"
              fill="rgb(95, 95, 95)"
              d="M31.034,28.843 L2.404,28.843 C1.300,28.843 0.404,27.947 0.404,26.843 L0.404,25.959 C0.404,24.854 1.300,23.959 2.404,23.959 L31.034,23.959 C32.138,23.959 33.034,24.854 33.034,25.959 L33.034,26.843 C33.034,27.947 32.138,28.843 31.034,28.843 ZM31.034,17.093 L2.404,17.093 C1.300,17.093 0.404,16.197 0.404,15.093 L0.404,14.209 C0.404,13.104 1.300,12.209 2.404,12.209 L31.034,12.209 C32.138,12.209 33.034,13.104 33.034,14.209 L33.034,15.093 C33.034,16.197 32.138,17.093 31.034,17.093 ZM31.034,5.093 L2.404,5.093 C1.300,5.093 0.404,4.197 0.404,3.093 L0.404,2.209 C0.404,1.104 1.300,0.209 2.404,0.209 L31.034,0.209 C32.138,0.209 33.034,1.104 33.034,2.209 L33.034,3.093 C33.034,4.197 32.138,5.093 31.034,5.093 Z"
            />
          </svg>

          <svg
            class="svg-close"
            :style="{ opacity: menuActive ? 1 : 0 }"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="29px"
            height="29px"
          >
            <path
              fill-rule="evenodd"
              fill="rgb(95, 95, 95)"
              d="M28.071,4.817 L18.276,14.612 L27.893,24.228 C28.674,25.009 28.674,26.275 27.893,27.056 L27.268,27.682 C26.487,28.463 25.220,28.463 24.439,27.682 L14.823,18.065 L4.998,27.890 C4.217,28.671 2.951,28.671 2.170,27.890 L1.545,27.265 C0.764,26.484 0.764,25.217 1.545,24.436 L11.369,14.612 L1.366,4.609 C0.585,3.828 0.585,2.561 1.366,1.780 L1.992,1.155 C2.773,0.374 4.039,0.374 4.820,1.155 L14.823,11.158 L24.618,1.364 C25.399,0.582 26.665,0.582 27.446,1.364 L28.071,1.989 C28.852,2.770 28.852,4.036 28.071,4.817 Z"
            />
          </svg>
        </div>
        <a target="_blank" href="https://store.steampowered.com/app/1260320/_/">
          <HoverBtn
            class="play-now txt-zh"
            v-if="this.$i18n.locale == 'zh'"
            :height="'60px'"
            :scale="''"
            :src="require('../assets/images/menu_button_playnow_normal_cn.png')"
            :srchover="
              require('../assets/images/menu_button_playnow_hover_cn.png')
            "
            :srcset="
              require(`../assets/images/menu_button_playnow_normal_cn@2x.png`)
            "
            :srcsethover="
              require(`../assets/images/menu_button_playnow_hover_cn@2x.png`)
            "
          ></HoverBtn>
          <HoverBtn
            class="play-now txt-en"
            v-else
            :src="require('../assets/images/menu_button_playnow_normal.png')"
            :maxHeight="'59px'"
            :srchover="
              require('../assets/images/menu_button_playnow_hover.png')
            "
            :srcset="
              require(`../assets/images/menu_button_playnow_normal@2x.png`)
            "
            :srcsethover="
              require(`../assets/images/menu_button_playnow_hover@2x.png`)
            "
          ></HoverBtn>
        </a>
      </div>
    </div>
    <transition name="fade">
      <div class="right-bg" v-if="menuActive"></div>
    </transition>
    <transition name="slide">
      <div
        class="right-tab"
        v-if="menuActive"
        @click="closeSideMeau"
        ref="rightTab"
      >
        <div class="right-menu">
          <div class="nav">
            <div class="line">
              <a
                v-if="this.$i18n.locale == 'zh'"
                target="_blank"
                href="https://partyanimals.cn/media"
                >{{ $t("m.header.media") }}</a
              >
              <a
                v-if="this.$i18n.locale != 'zh'"
                target="_blank"
                href="https://partyanimals.com/media"
                >{{ $t("m.header.media") }}</a
              >
            </div>

            <div class="line login-line">
              <router-link to="/">{{ $t("m.header.supportup") }}</router-link>
              <div
                class="log-bot"
                @click="login()"
                v-if="!this.$store.state.login"
              >
                <svg
                  data-v-61dd7a3d=""
                  version="1.1"
                  id="图层_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 26.8 26.8"
                  style="fill: #5b5b5b"
                  xml:space="preserve"
                  class="user"
                >
                  <path
                    data-v-61dd7a3d=""
                    d="M13.4,0C6,0,0,6,0,13.4c0,7.4,6,13.4,13.4,13.4c7.4,0,13.4-6,13.4-13.4C26.8,6,20.8,0,13.4,0z M13.4,3.9
	c2.6,0,4.7,2.1,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7C8.7,6,10.8,3.9,13.4,3.9z M13.4,23.9c-2.8,0-5.4-1.1-7.3-2.9
	c1-3.1,3.9-5.1,7.2-5.1c3.4,0,6.3,2.1,7.3,5.1C18.8,22.7,16.2,23.9,13.4,23.9z"
                    class="st0"
                  ></path>
                </svg>
                {{ $t("m.header.sign") }}
              </div>
              <!-- <div class="log-bot hasLog" > -->
              <div class="log-bot hasLog" v-else>
                <span class="name">
                  <el-popover placement="top" width="92" trigger="click">
                    <div
                      class="logout-btn"
                      style="text-align: center; margin: 0"
                    >
                      <el-button type="primary" size="mini" @click="Logout()">
                        {{ $t("m.header.out") }}</el-button
                      >
                    </div>
                    <el-button slot="reference">
                      <div class="head">
                        <img :src="this.$store.state.avatarUrl" alt="" />
                      </div>
                      <div class="login-name">
                        {{ this.$store.state.userName }}
                      </div>
                    </el-button>
                  </el-popover></span
                >
              </div>
            </div>
            <div class="line">
              <div class="second-level">
                <router-link
                  to="/"
                  :class="{ active: this.$route.name == 'home' }"
                  >{{ $t("m.header.support") }}</router-link
                >
                <a
                  target="_blank"
                  v-if="$i18n.locale == 'en'"
                  :href="'https://trello.com/b/aDzm1dnM/'"
                  :class="{ active: this.$route.name == 'KNOW ISSUES' }"
                  >{{ $t("m.header.known") }}</a
                >
                <a
                  target="_blank"
                  v-if="this.$i18n.locale != 'en'"
                  :href="'https://banlikanban.com/kanban/64d1afd3580bfb2671125901/%E6%AC%A2%E8%BF%8E%E6%9F%A5%E7%9C%8B%E6%9D%BF%E6%A0%97%E7%9C%8B%E6%9D%BF%E3%80%8C%E7%8C%9B%E5%85%BD%E6%B4%BE%E5%AF%B9%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98%E3%80%8D'"
                  :class="{ active: this.$route.name == 'KNOW ISSUES' }"
                  >{{ $t("m.header.known") }}</a
                >
                <router-link
                  to="/server"
                  :class="{ active: this.$route.name == 'Serve' }"
                  >{{ $t("m.header.server") }}</router-link
                >
                <router-link
                  :to="
                    this.$store.state.login ? '/tickets/my-tickets' : '/login'
                  "
                  :class="{ active: this.$route.name == 'Myticket' }"
                  >{{ $t("m.header.ticket") }}</router-link
                >

                <router-link
                  :to="
                    this.$store.state.login ? '/tickets/new-tickets' : '/login'
                  "
                  >{{ $t("m.header.submit") }}</router-link
                >
                <!-- <btn class="btn" :width="'180px'" :route="this.$store.state.login ? '/tickets/new-tickets' : '/login'"
                  :text="'SUBMIT A TICKET'">
                </btn> -->
              </div>
            </div>
            <div class="line">
              <a
                v-if="this.$i18n.locale != 'en'"
                href="https://forum-china.partyanimals.com/"
              >
                {{ $t("m.header.forum") }}</a
              >
              <a
                v-if="this.$i18n.locale == 'en'"
                href="https://forum.partyanimals.com/"
              >
                {{ $t("m.header.forum") }}</a
              >
            </div>

            <div class="line" v-if="this.$i18n.locale != 'en'">
              <a style="cursor: pointer">猛兽商城</a>
            </div>
            <div class="line" v-if="this.$i18n.locale != 'en'">
              <div class="second-level">
                <a target="_blank" :href="'https://partyanimals.tmall.com/'"
                  >天猫旗舰店</a
                >
                <a
                  target="_blank"
                  :href="'https://mall.jd.com/index-13161900.html'"
                  >京东旗舰店</a
                >
              </div>
            </div>
            <div class="line">
              <a
                v-if="this.$i18n.locale != 'en'"
                href="https://partyanimals.cn/events"
              >
                {{ $t("m.header.event") }}</a
              >
              <a
                v-if="this.$i18n.locale == 'en'"
                href="https://partyanimals.com/twitch-drops"
              >
                {{ $t("m.header.event") }}</a
              >
            </div>
            <!-- <div class="line">
              <a v-if="this.$i18n.locale == 'zh'" href="https://partyanimals.cn/creators"> {{ $t("m.header.creators") }}</a>
              <a v-if="this.$i18n.locale != 'zh'" href="https://partyanimals.com/creators"> {{ $t("m.header.creators") }}</a>
            </div> -->
          </div>
          <SmallBar
            class="phone"
            :ul="[
              { lang: $t('m.header.zh'), data: 'zh' },
              { lang: $t('m.header.en'), data: 'en' },
            ]"
          ></SmallBar>
        </div>
        <transition name="fade">
          <div class="popup" v-if="isPopupVisible" ref="popup">
            <div class="logout" @click="logout()"></div>
            登出
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
//此页为通用页头

import HoverBtn from "../components/HoverBtn.vue";
import Btn from "../components/Btn.vue";
import SmallBar from "../components/SmallBar.vue";
import ShopBar from "../components/ShopBar.vue";
export default {
  components: { HoverBtn, Btn, SmallBar, ShopBar },
  name: "app-header",
  inject: ["reload"],
  data() {
    return {
      isPopupVisible: false,
      visible: false,
      num: 0,
      dis: "block",
      isActive: true,
      screenWidth: document.body.clientWidth,
      support: true,
      changeLang: false,
      isLogin: false,
      menuActive: false,
      keyValue: 1,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("click", (event) => {
      var a = document.querySelector(".outbox");
      var b = document.querySelector(".head");
      var d = document.querySelector(".head img");
      var c = document.querySelector(".name");
      var e = document.querySelector(".hasLogin");
      if (
        event.target != a &&
        event.target != b &&
        event.target != c &&
        event.target != d &&
        event.target != e
      ) {
        this.isLogin = false;
      }
    });
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    console.log(this.$store);
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name) {
        this.menuActive = false;
        // 关闭菜单时
        document.body.classList.remove("no-scroll");
      }
    },
    menuActive(newValue, oldValue) {
      console.log("menuActive:", newValue, oldValue);
      // 在这里可以执行相应的操作
      if (newValue) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // handleClick() {

    //   if (this.$route.path == '/tickets/new-tickets') {
    //     console.log(this.reload);
    //     this.reload()
    //   }
    togglePopup() {
      this.isPopupVisible = !this.isPopupVisible;
    },
    closePopupOnClickOutside(event) {
      if (!this.isPopupVisible && !this.$refs.popup.contains(event.target)) {
        console.log("1111");

        this.isPopupVisible = false;
      }
    },
    // },
    closeSideMeau(e) {
      if (e.target == this.$refs.rightTab) {
        this.menuActive = false;
      }
      if (e.target.tagName.toLowerCase() == "a") {
        this.menuActive = false;
      }
      console.log(e.target);
    },
    handleResize() {
      const width = window.innerWidth;
      if (width >= 1100) {
        this.menuActive = false;
        // 关闭菜单时
        document.body.classList.remove("no-scroll");
      }
    },
    showMenu() {
      this.menuActive = !this.menuActive;
    },
    login() {
      this.menuActive = false;
      this.$router.push("/login");
    },
    openSecondNav() {
      this.support = true;
    },
    closeSecondNav() {
      this.support = false;
    },
    goLogin() {
      this.$router.push("/login");
      this.closeMenu();
    },
    //禁止页面滑动
    stop() {
      var mo = function (e) {
        passive: false;
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    //取消滚动限制
    move() {
      var mo = function (e) {
        passive: false;
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    openMenu() {
      document.querySelectorAll(".menu-bg")[0].style.display = "block";
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.stop();
      setTimeout(() => {
        this.isActive = false;
      }, 1);
    },
    closeMenuG(event) {
      let box = document.querySelectorAll(".menu-box")[0];

      console.log(event.target);
      this.move();
      if (event.target != box) {
        this.isActive = true;
        setTimeout(() => {
          document.querySelectorAll(".menu-bg")[0].style.display = "none";
        }, 400);
      }
    },
    closeMenu(el) {
      this.move();
      this.isActive = true;
      setTimeout(() => {
        document.querySelectorAll(".menu-bg")[0].style.display = "none";
      }, 400);
    },
    Logout() {
      this.visible = false;
      this.isLogin = false;
      this.$store.commit("Logout");
      if (
        this.$route.name == "Myticket" ||
        this.$route.name == "submit a ticket" ||
        this.$route.name == "MyTicket"
      ) {
        console.log("退出登录");
        this.$router.push("/login");
      }
    },
    showList() {},
  },
  created() {},
};
</script>
<style lang="scss" scoped>
// @import "../assets/scss/header.scss";
.el-popover.el-popper {
}

.container {
  transition: all 0.5s;
  // overflow: hidden;
  height: 140px;
  background-color: #3c3c3c;

  .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 2100;

    color: #5c5956;
    font-size: 18px;
    // text-shadow: 0 1px 2px rgb(0 0 0 / 10%), 0 2px 4px rgb(33 35 52 / 15%);
    font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei,
      sans-serif;
    transition: background-color ease-in 0.15s, box-shadow ease-in 0.15s;
    // box-shadow: 0 2px 6px 1px rgb(0 0 0 / 10%);
    background: url("../assets/images/nav_bg.png") #00000000 repeat-x;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;

    .menu {
      position: absolute;
      right: 199px;
      height: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      &.zh {
        right: 193px;
      }

      .small {
        display: none;
      }

      &:hover {
        fill: #ffc300;
      }

      .play-now {
        top: -27px;
        left: 33px;
      }

      .line {
        height: 20px;
        border-right: 2px solid #9099ae;
        opacity: 0.5;
        margin: 0 15px;

        &.login-line {
          display: flex;
          justify-content: space-between;
        }
      }

      img.user {
        width: 26px;
        margin-right: 15px;
      }

      img.login {
        height: 16px;
      }

      img.global {
        width: 26px;
        cursor: pointer;
      }
    }

    .logo {
      z-index: 900;
      margin-right: 20px;

      a {
        position: absolute;
        display: block;
        width: 124px;
        margin-left: 22px;
        top: 16px;
        height: 80px;
        background: image-set(
            url("../assets/images/logo.png") 1x,
            url("../assets/images/logo@2x.png") 2x
          )
          center top no-repeat;
        background-size: 100%;
        text-indent: -9999em;
        transition: color ease 0.2s;
      }
    }

    .nav {
      height: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 157px;
      transition: all 0.5s;
      overflow: hidden;

      a.active {
        color: #f87e35;
      }

      &.second {
        margin-top: 70px;
        padding-left: 178px;
        margin-left: 0;
        z-index: 5;
        width: 100%;
        background-color: rgba($color: #2e2e2e, $alpha: 0.9);
        color: #fff;
        font-size: 17px;

        &.en {
          font-size: 16px;

          a {
            padding: 0 18px;
          }
        }

        a.active {
          color: #ffc844;
        }

        #sub-btn {
          min-width: 26px;
          height: 22px;
          margin-left: 15px;
          font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei,
            sans-serif;
          color: #fff;
          font-size: 17px;
          text-align: center;
          // background-color: #ffdd40;
          line-height: 28px;
          border-radius: 22px;
          padding: 8px 22px 10px;
          transition: all 0.25s ease;
          border: 2px solid #fff;
          cursor: pointer;

          &:hover,
          &.active {
            border-color: #ffc640;
            color: #ffc640;
          }
        }

        .btn {
          margin-left: 20px;
        }
      }

      &.first {
        z-index: 10;
        font-size: 20px;

        a:hover {
          color: #f87e35;
        }
      }

      a {
        padding: 0px 20px;
        transition: all 0.4s;
        height: 100%;
        line-height: 75px;
        cursor: pointer;

        &:hover {
          color: #ffc000;

          svg {
            color: #ffc000;
            fill: #ffc000;
          }
        }
      }
    }
  }
}

.nav.second .hasLogin {
  position: absolute;
  right: 12px;
  display: flex;
  flex-direction: row;
  transition: color 0.4s;

  &:hover {
    .head {
      background: url("../assets/images/menu_icon_account_hover.svg");
    }

    color: #ffc000;

    svg {
      fill: #ffc000;
    }
  }

  .name {
    display: inline-block;
    max-width: 70px;
    /* height: 17px; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 0 0 12px;
    line-height: 15px;
    //原来2
    padding-top: 3px;
    font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei,
      sans-serif;
    cursor: pointer;
  }
}

.hasLogin {
  font-family: "Nunito-Bold";
  height: 65px;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.phone {
    display: none;
  }

  .outbox {
    position: absolute;
    width: 126px;
    top: 57px;
    font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei,
      sans-serif;
    font-size: 16px;
    color: #5c5956;
    line-height: 2.3;
    background-color: rgb(255, 255, 255);
    border: 1px solid #e1e0dd;
    box-shadow: 0px 10px 24px 0px rgba(0, 0, 0, 0.08);
    border-radius: 18px;
    padding: 0px;
    right: -2px;

    // padding: ;
    .innerbox {
      margin: 10px;

      text-align: left;
      border-radius: 14px;
      transition: all 0.2s ease;

      .li {
        transition: all 0.4s;
        text-align: center;
        padding: 4px 12px 0px;
        cursor: pointer;
        border-radius: 12px;

        &:hover {
          background-color: #fceaad;
        }

        &:active {
          background-color: #ffcc00;
          color: #ffffff;
        }
      }
    }

    z-index: 200;
  }

  .head {
    width: 30px;
    z-index: 100;
    height: 30px;
    cursor: pointer;
    background: url("../assets/images/menu_icon_account.svg");
    transition: all 0.4s;

    img {
      width: 31px;
      z-index: 100;
      height: 31px;
      border-radius: 30px;
    }

    svg {
      fill: #fff;
      transition: fill 0.4s;
    }
  }

  // .logout {
  //     position: absolute;
  //     top: 30px;
  //     max-width: 225px;
  //     height: 100%;
  //     .btn {
  //         width: 100%;
  //     }
  // }
}

.container .right-tab .right-menu .nav .line .log-bot {
  display: none;
}

.log {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  position: absolute;
  right: 28px;
  height: 26px;
  width: 110px;
  transition: margin-top 0.4s;

  &:hover {
    .user,
    .login {
      fill: #ffc000;
    }
  }

  .user {
    height: 26px;
    transition: fill 0.4s;
    margin-right: 15px;
    fill: #ffffff;
  }

  .login {
    height: 14px;
    fill: #ffffff;
    transition: fill 0.4s;

    &.zh {
      height: 18px;
    }
  }
}

@media screen and (max-width: 1100px) {
  .hasLogin {
    &.phone {
      display: flex;
      justify-content: flex-start;

      margin-left: 40px;
    }

    &.win {
      display: none;
    }
  }

  .container {
    height: 45px;

    .header .logo a {
      width: 54px;
      height: 60px;
      top: 6px;
      left: 1px;
    }

    .right-bg {
      position: absolute;
      bottom: 0;
      top: 0;
      right: 0;
      left: 0;
      background-color: rgb(0 0 0 / 40%);
      z-index: 19;
    }

    .right-tab {
      position: fixed;
      bottom: 0;
      top: 0;
      right: 0;
      left: 0;
      z-index: 2000;

      .popup {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 400;
        height: 50px;
        text-align: center;
        line-height: 50px;
        box-shadow: 0px 20px 48px 0px rgba(0, 0, 0, 0.2),
          inset 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
        background-color: #fff;
        font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei,
          sans-serif;
        color: #5b5b5b;
        transition: all 0.3s;
        cursor: pointer;

        &:hover {
          color: #ffc640;
        }

        .logout {
          background-color: #fff;
        }
      }

      .right-menu {
        position: absolute;
        box-shadow: 0px 20px 48px 0px rgba(0, 0, 0, 0.2),
          inset 0px 2px 7px 0px rgba(0, 0, 0, 0.1);
        bottom: 0;
        top: 45px;

        right: 0;
        width: 100%;
        background: url("../assets/images/submit_bg.png") repeat;
        max-width: 320px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .phone {
          position: relative;
        }

        .nav {
          display: flex;
          font-size: 20px;
          font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei,
            sans-serif;
          flex-direction: column;
          margin: 10px 20px 80px;
          align-items: flex-start;
          color: #5b5b5b;

          .line {
            width: calc(100% - 40px);
            border-bottom: 2px solid #07000211;
            padding: 7px 20px 2px;
            margin: 0 auto;
            position: relative;

            &.login-line {
              display: flex;
              justify-content: space-between;
            }

            a {
              transition: all 0.4s;

              &:hover {
                color: #f2893c;
              }
            }

            .log-bot {
              display: block;
              transition: color 0.4s;

              svg {
                color: #5b5b5b;
                transition: fill 0.4s;
              }

              &:hover {
                color: #f2893c;

                svg {
                  fill: #f2893c !important;
                }
              }

              &.hasLog {
                right: 20px;
                top: 6px;
                position: absolute;
                font-size: 18px;

                .name {
                  line-height: 1.5;
                  position: relative;
                  top: 1px;
                  color: #5b5b5b;
                  transition: all 0.3s;

                  max-width: 180px;

                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;

                  .el-popover__reference {
                    display: flex;
                    align-items: center;
                    border-radius: 18px;

                    .head {
                      line-height: 16px;
                    }
                  }

                  .login-name {
                    max-width: 100px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }

                  &:hover {
                    color: #ffc640;
                  }
                }

                svg {
                  transition: all 0.4s;
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  width: 31px;
                  margin-top: -6px;
                  margin-right: 15px;
                  fill: #5f5f5f;
                }

                .user {
                  margin-top: -4px;
                }
              }

              .user {
                height: 31px;
                margin-right: 10px;
                margin-top: -4px;
              }

              .login {
                height: 14px;
              }

              .li {
                font-size: 16px;
                width: 200px;
              }

              .head img {
                border-radius: 50px;
                margin-right: 8px;
                max-width: 26px;
              }

              cursor: pointer;
              font-size: 18px;
              display: flex;
              height: 45px;

              line-height: 0px;
              position: relative;
              top: 1px;

              align-items: center;
            }

            .log {
              position: absolute;
              top: 40px;
              right: 20px;
              scale: 1.1;

              .li {
                font-size: 20px;
              }

              .user {
                margin-right: 10px;
              }
            }

            .second-level {
              width: calc(100%);
              padding: 8px 13px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              align-content: center;

              a {
                color: #898989;

                font-size: 18px;
                transition: all 0.4s;

                &:hover {
                  color: #f2893c;
                }
              }
            }
          }

          a {
          }
        }
      }
    }

    .small {
      display: block !important;
      cursor: pointer;
      scale: 0.6;
      margin-top: 11px;
      margin-left: 20px;

      .img {
        background-image: url(../assets/images/svg_menu.svg);
        width: 34px;
        height: 29px;
        transition: all 0.5s;

        &.active {
          background-image: url(../assets/images/svg_close.svg);
        }
      }

      svg {
        transition: all 0.2s;
      }
    }

    .svg-close {
      position: absolute;
      left: 2px;
    }

    .play-now {
      display: none;
    }

    .header {
      height: 45px;
      box-shadow: 0 4px 7px rgba(0, 0, 0, 0.05);

      .menu {
        right: 20px;
      }

      .menu.zh {
        right: 20px;
      }

      .nav.first {
        display: none;
      }

      .nav.second {
        // display: none;
        margin-top: -30px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
}
</style>
